import { useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import trackGAEvent from '../../helper/GoogleAnalytics';

const UTM_KEYS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
] as const;

const UTMTracker: React.FC = () => {
  const location = useLocation();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const utmParams: Record<string, string> = {};

    UTM_KEYS.forEach((key) => {
      const value = searchParams.get(key);
      if (value) {
        utmParams[key] = value;
      }
    });

    if (Object.keys(utmParams).length > 0) {
      const { utm_source: source, utm_content: content } = utmParams;
      const followup = `${content}_${source}`;

      trackGAEvent('payment_link_clicked', { ...utmParams, followup });

      // Remove UTM parameters from URL after tracking
      const newUrl = new URL(window.location.href);
      UTM_KEYS.forEach((key) => newUrl.searchParams.delete(key));
      window.history.replaceState({}, '', newUrl.toString());
    }
  }, [location]);

  return null;
};

export default UTMTracker;
